/**
 * @generated SignedSource<<142350677583825fa114d01e8067ae41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswProjectMenu$data = {
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly softwareBoardCount: AGG$Long | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JswExpandableProject" | "JswExpandableProjectNew" | "JswNonExpandableProject">;
  readonly " $fragmentType": "JswProjectMenu";
};
export type JswProjectMenu$key = {
  readonly " $data"?: JswProjectMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswProjectMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "JswProjectMenu",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "softwareBoardCount"
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswNonExpandableProject"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "JswExpandableProject"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "JswExpandableProjectNew"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "ef673d7daab31033c619bf95c78cd4b4";

export default node;
